import { LegalPage } from "../components/LegalPage";
import { PRIVACY_UPDATED, PRIVACY_SECTIONS } from "../data/privacyPolicy";

export default function PrivacyPolicy() {
  return <LegalPage title="Privacy Policy" updated={PRIVACY_UPDATED} sections={PRIVACY_SECTIONS} testId="privacy-policy-page" />;
}
